import { connect } from 'react-redux';
import CrossPageActionTracker from './CrossPageActionTracker';
import { trackPreviousMonolithAction, destinationPageActions } from '../destinationPageActions';

const mapDispatchToProps = {
    trackPreviousMonolithAction,
    ...destinationPageActions,
};

export default connect(null, mapDispatchToProps)(CrossPageActionTracker);
